import '../styles/Home.css';


import empleoscuscofirst from '../assets/empleoscuscofirst.png';
import profileImage from '../assets/profile-image.gif';

import contanciasnodeudorfirst from '../assets/contanciasnodeudorfirst.png';


export function Home(){

  return(
    <section id="home" className="home">
      <div className="home-content">
        <h1 className="principal-title">Cristian Becerra</h1>
        <h2 className="principal-subtitle">Especialista en Transformación Digital</h2>
        <p className="principal-tagline">Ingeniero Informático y de Sistemas. Modernizo servicios y procesos con sistemas web, móviles y geoespaciales para instituciones públicas y privadas.</p>


        <a href="#contact" className="contact-btn">Contáctame</a>


        <div className="last-projects">
          <h3 className="title">Proyectos destacados</h3>
          <div className="last-projects-content">
            <a title="Imagen de 'Consulta de Notarios'" href="https://github.com/Becessj/Consulta-Notarias" target="_blank" rel="noopener noreferrer"><img src={contanciasnodeudorfirst} title="Imagen de 'Consulta de Notarios'" alt="Consulta de Notarios" className="last-project-image" /></a>
            <a title="Imagen de 'Empleos Cusco'" href="https://github.com/Becessj/App-Empleo-Cusco" target="_blank" rel="noopener noreferrer"><img src={empleoscuscofirst} title="Imagen de 'Empleos Cusco'" alt="SearchImg" className="last-project-image" /></a>
          </div>
        </div>
        <img src={profileImage} alt="Imagen de Cristian Becerra" className="profile-image" />
      </div>
    </section>
  );
}